module.exports = __webpack_public_path__ + "static/media/InterpretingSpreadsFiveCards.b7b39d1c.jpg";